'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _Modal = require('scripts/components/Modal');

var dom = {
  productImage: '[product-main-image]',
  addToCart: '[data-oos-atc]',
  OOSImage: '[data-oos-product-image]',
  OOSId: '[data-oos-product-id]'
};

var setupOOSModalContent = function setupOOSModalContent(event) {
  event.preventDefault();
  var $self = $(event.currentTarget);
  var $modalImage = $(dom.OOSImage);

  // Checks for modalImage, only non Travel bag products will have image
  if ($modalImage.length) {
    var $productImage = $(dom.productImage);
    var img = new Image();
    img.onload = function () {
      $modalImage.attr('src', img.src);
      $modalImage.attr('srcset', img.src);
      (0, _Modal.show)('oos');
    };
    $(dom.OOSId).val($self.attr('data-variant-id'));
    img.src = $productImage[0].hasAttribute('srcset') ? $productImage[0].currentSrc : $productImage.attr('src');
    $modalImage.attr('alt', $productImage.attr('alt'));
  } else {
    (0, _Modal.show)('oos');
  }
};

var bindUIActions = function bindUIActions() {
  $(document).on('click', dom.addToCart, setupOOSModalContent);
};

var init = exports.init = function init() {
  bindUIActions();
};